// Le lien d'un mail Radar ouvert alors qu'un AUTRE compte est connecté dans ce
// navigateur (issue #149). Le serveur ne remplace plus la session : il ramène
// ici avec `autreCompte=<le lien>`, et c'est la personne qui décide d'en
// changer. Changer de compte déconnecte, puis rejoue le lien tel quel, qui
// connecte alors le compte du mail.

import { useState } from 'react'
import { CircleAlert } from 'lucide-react'
import { post } from '../lib/api'
import { useT } from '../lib/i18n'
import { parseQuery, setQuery } from '../lib/router'

export function BandeauAutreCompte() {
  const t = useT()
  const [ferme, setFerme] = useState(false)
  const q = parseQuery(location.hash)
  const lien = q.get('autreCompte')
  if (!lien || ferme) return null
  return (
    <div className="bandeau-taches" role="status">
      <div className="tache">
        <CircleAlert size={15} />
        <span>{t('autreCompte.texte')}</span>
        <button
          className="btn-primary btn-sm"
          onClick={async () => {
            await post('/api/auth/logout').catch(() => {})
            window.location.href = `/api/courriers/ouvrir?${lien}`
          }}
        >
          {t('autreCompte.changer')}
        </button>
        <button
          className="btn-secondary btn-sm"
          onClick={() => {
            q.delete('autreCompte')
            setQuery(q)
            setFerme(true)
          }}
        >
          {t('autreCompte.rester')}
        </button>
      </div>
    </div>
  )
}
